import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=2dda35e8&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=2dda35e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports